module.exports = __webpack_public_path__ + "static/media/success.ab6b6e39.svg";